import React from "react";
import * as typo  from "../utilities/getCustomTypography";
import * as tag from "../constants/customMetadataConstants";
import * as portalShared from "../shared/metadataConstantsAndUtilities"
import * as icon from "../constants/iconConstants";


export function getLikertTitleObj(savedObjs, orderedAnswers, floatDirection, pyramidMode = false, LeftOnly, rightOnly) {

    let defaultWidthNum = 44;
    let defaultWidthHalfStr = (defaultWidthNum / 2) + "px";
    let defaultWidth1xStr = defaultWidthNum + "px";
    let defaultWidth2xStr = (defaultWidthNum * 2) + "px";
    let defaultWidth3xStr = (defaultWidthNum * 3) + "px";

    let titleObj = {
        likertTitleType: icon.LIKERT_TITLES_HIDDEN, // Default: titles are "hidden"
        embeddedTitles: false,
        useGraybarHeader: false,
        useStandardHeader: false,
        //useAnswersHeader: false,
        hasTitle: false,
        leftTitle: "",
        centerTitle: "",
        rightTitle: "",
        defaultWidthNum: defaultWidthNum,
        defaultWidthHalfStr: defaultWidthHalfStr,
        defaultWidth1xStr: defaultWidth1xStr,
        defaultWidth2xStr: defaultWidth2xStr,
        defaultWidth3xStr: defaultWidth3xStr,
        unitPadWidth: "0px",
        initPadWidth: "0px",
        leftWidth: "0px",
        centerWidth: "0px",
        rightWidth: "0px",
        htmlTitleDiv: "",
        pyramidCustomTitleTopLeft: null,
        pyramidCustomTitleBottomLeft: null,
        //getTitle: function () {return this.htmlTitleDiv}
    };

    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    if (orderedAnswers.length === 0) {
        return titleObj; // NOTE: If no answers then do NOT render titles
    }

    if (!savedObjs.isFirstQuestionOfGroupLikert) {
        return titleObj;  // NOTE: Bail out if NOT first question of a group likert
    }
    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    // -----------------------------------------------------------------------------------------------------------------
    // Suppress titles in a likert group for all but the first question
    // if (savedObjs.isGroupLikert && !savedObjs.isFirstQuestionOfGroupLikert) {
    //     return titleObj;
    // }
    // -----------------------------------------------------------------------------------------------------------------

    // -----------------------------------------------------------------------------------------------------------------
    // Check for specific title selections
    // LIKERT_TITLES_ALL = "As title above";  // Thumbs, Stars and Faces
    // LIKERT_TITLES_LR = "As title above (LR) only";  // Stars and Faces
    // LIKERT_TITLES_LCR = "As title above (LCR) only)";  // Stars and Faces with odd number of answers
    // LIKERT_TITLES_HIDDEN = "Hidden";  // Thumbs, Stars and Faces
    // LIKERT_TITLES_EMBEDDED = "Embedded";  // Circles and Squares Answer Text 1 or 2 characters embedded in icon


    // See if any of the answers have ICON_TITLE set to "hidden" i.e. icon.LIKERT_TITLES_HIDDEN
    for (let i = 0; i < orderedAnswers.length; i++) {
        if (tag.metadataExists(orderedAnswers[i], icon.ICON_TITLES)) {
            titleObj.likertTitleType = tag.metadataValue(orderedAnswers[i], icon.ICON_TITLES);
            if (titleObj.likertTitleType === icon.LIKERT_TITLES_EMBEDDED) {
                titleObj.embeddedTitles = true;
                titleObj.likertTitleType = icon.LIKERT_TITLES_HIDDEN;  // If titles are embedded then set back to hidden
            }
            break;
        }
    }

    // If radios and any answers do not have HIDE_BUTTONGROUP_NAME then show answerText above each radio
    let radioShowAnswerTextAsTitle = false;
    if (titleObj.likertTitleType === icon.LIKERT_TITLES_ALL) {
        radioShowAnswerTextAsTitle = true;

        for (let i = 0; i < orderedAnswers.length; i++) {
            if (tag.metadataExists(orderedAnswers[i], portalShared.HIDE_BUTTONGROUP_NAME)) {
                radioShowAnswerTextAsTitle = false;
                break;
            }
        }
    }




    // check for graybar
    // standard
    // answers as titles (radios and circles only)


    // -----------------------------------------------------------------------------------------------------------------
    // If radios and any answers do not have HIDE_BUTTONGROUP_NAME then show answerText above each radio
    // This takes priority over having titles set
    // let type = icon.TYPE_RADIO;
    // if (savedObjs.answers !== null) {
    //     type = tag.metadataValue(savedObjs.answers[0], icon.ICON_TYPE, "", icon.TYPE_RADIO);  // TODO need way to determine what type of input object we are dealing with question.metadata.likertStyles = "radios"
    // }

    //let rightAndAlignedWithQuestions = savedObjs.rightAlignLikertAnswers && savedObjs.alignQuestionsWithAnswers;

    //titleObj.useAnswersHeader = (tag.metadataExists(savedObjs.activeTemplate, portalShared.USE_LIKERT_ANSWERS_HEADER)); // I DON'T THINK USED ANYMORE

    if (savedObjs?.customTemplateObj) {
        titleObj.leftTitle = portalShared.legacyFixLikertObj(savedObjs.customTemplateObj, "titleLeft"); // LEGACY FIX
        titleObj.centerTitle = portalShared.legacyFixLikertObj(savedObjs.customTemplateObj, "titleCenter"); // LEGACY FIX
        titleObj.rightTitle = portalShared.legacyFixLikertObj(savedObjs.customTemplateObj, "titleRight"); // LEGACY FIX
    }

    titleObj.hasTitle = !!titleObj.leftTitle || !!titleObj.centerTitle || !!titleObj.rightTitle;

    // If right aligned flip left and right title
    let alignAnswersRight = "";
    if (savedObjs?.customTemplateObj) {
        alignAnswersRight = portalShared.legacyFixLikertObj(savedObjs.customTemplateObj, "alignAnswersRight"); // LEGACY FIX
    }
    if (alignAnswersRight) {
        let saveLeftTitle = titleObj.leftTitle;
        titleObj.leftTitle = titleObj.rightTitle;
        titleObj.rightTitle = saveLeftTitle;
    }


    // These answers are already flipped because they come from an ordered array
    // If no declared titles then check for declarations in answers
    if (!titleObj.hasTitle) {

        if (titleObj.likertTitleType === icon.LIKERT_TITLES_LR) {
            titleObj.hasTitle = true;
            titleObj.leftTitle = orderedAnswers[0].optionText;
            titleObj.rightTitle = orderedAnswers[orderedAnswers.length - 1].optionText;
        }
        if (titleObj.likertTitleType === icon.LIKERT_TITLES_LCR) {
            titleObj.hasTitle = true;
            titleObj.leftTitle = orderedAnswers[0].optionText;
            //tempCenterTitle = orderedAnswers[Math.floor(orderedAnswers.length / 2)].optionText;
            titleObj.rightTitle = orderedAnswers[orderedAnswers.length - 1].optionText;
        }
    }

    // In case were in pyramid mode center/right titles are ignored and handled by the getPyramid() function
    let tempLeftTitle = rightOnly ? "" : titleObj.leftTitle;
    let tempCenterTitle = (LeftOnly || rightOnly) ? "" : titleObj.centerTitle;
    let tempRightTitle = LeftOnly ? "" : titleObj.rightTitle;


    // If there are titles entered are the standard or graybar

    // else {
    //     return titleObj;  // !!!!!! bail out no titles !!!!!
    // }


    // label bar logic for both group and question level using graybar and standard labels, for all alignment possibilities
    //let useLabelBar = hasTitle && (((useGrayBarQuestionLevel || useStandardBarQuestionLevel) && (!rightAndAlignedWithQuestions || savedObjs.rightAlignLikertAnswers)) || (useStandardBarGroupLevel && !rightAndAlignedWithQuestions));


    //let orderedAnswers = answers;

    // IF aligned right reverse titles
    // if (!isLeftAligned) {
    //     orderedAnswers = answers.map(answer => answer).reverse();  // Reverse answers so fill from right to left for right aligned answers options
    // }




    let customTextObj = "";
    if (savedObjs?.customTemplateObj) customTextObj = portalShared.legacyFixLikertObj(savedObjs.customTemplateObj, "titlesCustomTextObj"); // LEGACY FIX // Check metadata for custom title overrides

    if ((titleObj.likertTitleType === icon.LIKERT_TITLES_HIDDEN) && (!titleObj.hasTitle)) {
        return titleObj;  // Bail out title is hidden
    }

    if (titleObj.likertTitleType === icon.LIKERT_TITLES_ALL) {


        // let radioShowAnswerTextAsTitle = false;  Seemed duplicate code
        // if (titleObj.likertTitleType === icon.LIKERT_TITLES_ALL) {
        //     radioShowAnswerTextAsTitle = true;
        //
        //     for (let i = 0; i < orderedAnswers.length; i++) {
        //         if (tag.metadataExists(orderedAnswers[i], portalShared.HIDE_BUTTONGROUP_NAME)) {
        //             radioShowAnswerTextAsTitle = false;
        //             break;
        //         }
        //     }
        // }


        if (radioShowAnswerTextAsTitle) {

            let tempStyles = {
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            };

            let CustomTypography = typo.getCustomTypography(customTextObj, "center", "caption");

            titleObj.htmlTitleDiv = <div style={{width: "100%"}}>
                <div key={"RadioTitles1-" + savedObjs.activeTemplate.id} style={{float: floatDirection, width: "100%"}}>
                    <div key={"RadioTitles2-" + savedObjs.activeTemplate.id} style={{
                        float: floatDirection,
                        width: titleObj.defaultWidth1xStr,
                        ...tempStyles
                    }}>&nbsp;</div>
                    {savedObjs.alignAnswersRight ?
                        orderedAnswers.slice(0).reverse().map((answer, index) =>
                            <div key={"OrderedAnswer-" + index + "-" + answer.id} style={{
                                float: floatDirection,
                                width: titleObj.defaultWidth1xStr,
                                ...tempStyles
                            }}>{<CustomTypography>{answer.optionText}</CustomTypography>}</div>)
                        :
                        orderedAnswers.map((answer, index) =>
                        <div key={"OrderedAnswer-" + index + "-" + answer.id} style={{
                            float: floatDirection,
                            width: titleObj.defaultWidth1xStr,
                            ...tempStyles
                        }}>{<CustomTypography>{answer.optionText}</CustomTypography>}</div>)
                    }
                    <div key={"RadioTitles3-" + savedObjs.activeTemplate.id} style={{
                        float: floatDirection,
                        width: titleObj.defaultWidth1xStr,
                        ...tempStyles
                    }}>&nbsp;</div>
                </div>
            </div>
        }

    }
    else {

        // Calc DIV widths for title text
        if (titleObj.hasTitle) {
            // See if there are 3 titles
            switch (savedObjs.answers.length.toString()) {
                case "2":
                    // No center title allowed
                    titleObj.unitPadWidth = titleObj.defaultWidth1xStr;
                    titleObj.leftWidth = titleObj.defaultWidth1xStr;
                    titleObj.rightWidth = titleObj.defaultWidth1xStr;
                    break;
                case "3":
                    if (tempCenterTitle) {
                        titleObj.leftWidth = titleObj.defaultWidth1xStr;
                        titleObj.centerWidth = titleObj.defaultWidth1xStr;
                        titleObj.rightWidth = titleObj.defaultWidth1xStr;
                    } else // Just left and right titles
                    {
                        titleObj.unitPadWidth = titleObj.defaultWidthHalfStr;
                        titleObj.leftWidth = titleObj.defaultWidth2xStr;
                        titleObj.rightWidth = titleObj.defaultWidth2xStr;
                    }
                    break;
                case "4":
                    // No center allowed
                    titleObj.unitPadWidth = titleObj.defaultWidthHalfStr;
                    titleObj.leftWidth = titleObj.defaultWidth2xStr;
                    titleObj.centerWidth = titleObj.defaultWidth1xStr;
                    titleObj.rightWidth = titleObj.defaultWidth2xStr;
                    break;
                case "5":
                    titleObj.unitPadWidth = titleObj.defaultWidthHalfStr;
                    titleObj.leftWidth = titleObj.defaultWidth2xStr;
                    titleObj.centerWidth = titleObj.defaultWidth2xStr;
                    titleObj.rightWidth = titleObj.defaultWidth2xStr;
                    break;
                case "6":
                    titleObj.leftWidth = titleObj.defaultWidth3xStr;
                    titleObj.centerWidth = titleObj.defaultWidth2xStr;
                    titleObj.rightWidth = titleObj.defaultWidth3xStr;
                    break;
                case "7":
                    titleObj.leftWidth = titleObj.defaultWidth3xStr;
                    titleObj.centerWidth = titleObj.defaultWidth3xStr;
                    titleObj.rightWidth = titleObj.defaultWidth3xStr;
                    break;
                case "10":
                    titleObj.leftWidth = titleObj.defaultWidth3xStr;
                    titleObj.centerWidth = (titleObj.defaultWidthNum * 6) + "px";
                    titleObj.rightWidth = titleObj.defaultWidth3xStr;
                    break;
                case "11":
                    if (pyramidMode) {
                        if (LeftOnly) {
                            titleObj.leftWidth = "160px";
                            titleObj.centerWidth = "0px";
                            titleObj.rightWidth = "0px";
                        }
                        else if (rightOnly) {
                            titleObj.leftWidth = "235px";
                            titleObj.centerWidth = "0px";
                            titleObj.rightWidth = "150px";
                        }
                    }
                    else {
                        titleObj.leftWidth = titleObj.defaultWidth3xStr;
                        titleObj.centerWidth = (titleObj.defaultWidthNum * 7) + "px";
                        titleObj.rightWidth = titleObj.defaultWidth3xStr;
                    }
                    break;
                // no default
            }

        }

        if (titleObj.hasTitle) {

            if (savedObjs?.customTemplateObj) {
                titleObj.useGraybarHeader = (portalShared.legacyFixLikertObj(savedObjs.customTemplateObj, "titleType") === "graybar"); // LEGACY FIX
                titleObj.useStandardHeader = (portalShared.legacyFixLikertObj(savedObjs.customTemplateObj, "titleType") === "standard"); // LEGACY FIX
            }
        }

        let CustomTypographyLeft = typo.getCustomTypography(customTextObj, "center", "caption");

        let CustomTypographyCenter = typo.getCustomTypography(customTextObj, "center", "caption");

        // If right only is true, then this is a pyramid and the title needs adjustments
        let CustomTypographyRight = typo.getCustomTypography(customTextObj, "center", "caption", rightOnly);

        if (pyramidMode) {
            titleObj.pyramidCustomTitleTopLeft = CustomTypographyLeft;
            titleObj.pyramidCustomTitleBottomRight = CustomTypographyRight;
        }

        let moreStyles = {
            backgroundColor: "white", // NOTE: Cant use gradients because its different divs
            paddingLeft: pyramidMode ? "7px" : "0px",
            display: "flex",
            justifyContent: pyramidMode ? "left" : "center",
            alignItems: pyramidMode ? "left" : "center",
            marginBottom: "10px",
        }

        let graybarColor = portalShared.DEFAULT_GRAYBAR_COLOR;
        let opacity = 100;
        if (savedObjs.customTemplateObj.likertObj.hasOwnProperty("grayBarColorObj")) {
            graybarColor = portalShared.getColor(savedObjs.customTemplateObj.likertObj.grayBarColorObj);
            opacity = savedObjs.customTemplateObj.likertObj.grayBarColorObj.opacity;
        }

        let hex = titleObj.useGraybarHeader ? graybarColor : "white";

        if (titleObj.useGraybarHeader) {
            //let graybarColor = tag.metadataValue(savedObjs.activeTemplate, portalShared.USE_LIKERT_GRAYBAR_COLOR, "", portalShared.DEFAULT_GRAYBAR_COLOR);

            moreStyles.backgroundColor = hexToRgba(hex, opacity)

            moreStyles.height = savedObjs.customTemplateObj.likertObj.grayBarHeight + "px";
        }

        titleObj.htmlTitleDiv = <div id={"likert-container-div-" + savedObjs.activeTemplate.id} style={{width: "100%"}}>
            <div id={"Title1-" + savedObjs.activeTemplate.id} key={"Title1-" + savedObjs.activeTemplate.id} style={{float: floatDirection, width: "100%"}}>
                <div id={"Title2-" + savedObjs.activeTemplate.id} key={"Title2-" + savedObjs.activeTemplate.id} style={{float: floatDirection, width: titleObj.unitPadWidth, ...moreStyles}}>&nbsp;</div>
                <div id={"Title3-" + savedObjs.activeTemplate.id} key={"Title3-" + savedObjs.activeTemplate.id} style={{
                    float: floatDirection,
                    width: titleObj.leftWidth,
                    ...moreStyles}}>{
                    <CustomTypographyLeft>{tempLeftTitle === "" ? '\u00A0' : tempLeftTitle.split("\\n").map((line, index) => (
                        //adds a newline character and replaces \n
                        <React.Fragment key={index}>
                            {line}
                            <br/>
                        </React.Fragment>
                    ))}</CustomTypographyLeft>
                }</div>
                <div id={"Title4-" + savedObjs.activeTemplate.id} key={"Title4-" + savedObjs.activeTemplate.id} style={{
                    float: floatDirection,
                    width: titleObj.centerWidth,
                    ...moreStyles
                }}>{
                    <CustomTypographyCenter>{tempCenterTitle === "" ? '\u00A0' : tempCenterTitle.split("\\n").map((line, index) => (
                        //adds a newline character and replaces \n
                        <React.Fragment key={index}>
                            {line}
                            <br/>
                        </React.Fragment>
                    ))}</CustomTypographyCenter>
                }</div>
                <div id={"Title5-" + savedObjs.activeTemplate.id} key={"Title5-" + savedObjs.activeTemplate.id} style={{
                    float: floatDirection,
                    width: titleObj.rightWidth,
                    borderRadius: titleObj.useGraybarHeader ? (savedObjs.rightAlignLikertAnswers ? '100px 0 0 100px' : '0 100px 100px 0') : "",
                    ...moreStyles
                }}>{<CustomTypographyRight>{tempRightTitle === "" ? '\u00A0' : tempRightTitle.split("\\n").map((line, index) => (
                    //adds a newline character and replaces \n
                    <React.Fragment key={index}>
                        {line}
                        <br/>
                    </React.Fragment>
                ))}</CustomTypographyRight>}</div>
            </div>
        </div>

    }

    return titleObj;
}

const hexToRgba = (hex, opacity) => {
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}